module.exports = __webpack_public_path__ + "img/3.5e0d5c5b.png";